import React from 'react';

class ListErrors extends React.Component {
    render() {
        const errors = this.props.errors;
        return (
            <div>
            {
                errors && errors.message !=null ? 
                    <ul className="error-messages">
                        <li>
                            {errors.message}
                        </li>
                    </ul> : ""
            }
            </div>
        );
    }
}

export default ListErrors;
